import { axios } from '@/lib/axios';
import { useQuery,useMutation } from 'react-query';

import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';

export type saveData = {
    id?: any;
  };
  
  export const deleteUser = ({
   id
  }: saveData) => {
        return axios.delete(`/superAdmin/delete-product/${id}`);
    
  };
  
  type UseAddPetOptions = {
    config?: MutationConfig<typeof deleteUser>;
  };
  
  export const useDeleteProduct = ({ config }: UseAddPetOptions = {}) => {
    return useMutation({
      onSuccess: (res: any, req: any) => {
        showNotification({
          type: 'success',
          title: 'Product deleted successfully.',
        });
      },
      ...config,
      mutationFn: deleteUser,
    });
  };
  
